import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
  STORE_LIVEORDERDATA,
  RowDataLive,
  STORE_LIVEDATA_ORDERNO,
  STORE_LIVEORDERDATA_ONHOLD,
  STORE_LIVEORDERDATA_RETURNED,
  STORE_LIVEDATA_ORDERID,
  RowDataCancel,
  STORE_CANCELORDERDATA,
  STORE_NEWORDERDATA
} from '../reducers/liveorderfile';

import axios, { AxiosResponse, AxiosError } from 'axios';
import { push } from 'react-router-redux';
import { ViewCompletedOrder, STORE_VIEWCOMPLETEDORDER } from 'src/reducers/completeorderfile';
import { STORE_SEARCHTRUE, STORE_SEARCHNAME, STORE_LOADER } from 'src/reducers/landingPage';
import { getCompleteOrderData } from './completeOrderAction';
import { STORE_ERROR_FILES_UPLOADED_MSG, STORE_ERROR_FILES_UPLOADED } from 'src/reducers/errors';
import { clearDataOnOpen, getRxOrderData, messageObjectTransform } from './rxformAction';
import { getDesignReadyOrderData, getMCompleteOrderData, getMHoldOrderData, getMInproductionOrderData, getMInproductionOrderDataFilter, getMNewOrderData } from './manufacturAction';
import {
  UserRxFormData,
  STORE_RXORDERDATA,
  STORE_GETMESSAGES,
  STORE_GETDATAFILES,
  STORE_DESIGNTYPE_RXFORM,
  STORE_MODEL_RXFORM,
  STORE_NOTATIONS_RXFORM,
  STORE_PRODUCTNAME_RXFORM,
  STORE_PRODUCT_RXFORM,
  GetFileData,
  GetUserMessage
} from 'src/reducers/rxForm';

export const getNewOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  axios({
    method: 'post',
    url: `${getState().environment.API_URL
      }loadOrderData?listType=brecdon2&userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    if (response.data.length === 1) {

      if (response.data[0].orderno !== '') {

        const newOrderData: RowDataLive[] = response.data;
        dispatch({ type: STORE_NEWORDERDATA, newOrderData } as AnyAction);
      } else {

        const newOrderData: RowDataLive[] = [];
        dispatch({ type: STORE_NEWORDERDATA, newOrderData } as AnyAction);
      }

    } else {

      const newOrderData: RowDataLive[] = response.data;
      dispatch({ type: STORE_NEWORDERDATA, newOrderData } as AnyAction);
    }

  }).catch(function (error: AxiosError) {

    const newOrderData: RowDataLive[] = [];
    dispatch({ type: STORE_NEWORDERDATA, newOrderData } as AnyAction);

  });

};
export const getLiveOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  axios({
    method: 'post',
    url: `${getState().environment.API_URL
      }loadOrderData?listType=brecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=LIVE`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    if (response.data.length === 1) {

      if (response.data[0].orderno !== '') {

        const liveOrderData: RowDataLive[] = response.data;
        dispatch({ type: STORE_LIVEORDERDATA, liveOrderData } as AnyAction);
      } else {

        const liveOrderData: RowDataLive[] = [];
        dispatch({ type: STORE_LIVEORDERDATA, liveOrderData } as AnyAction);
      }

    } else {

      const liveOrderData: RowDataLive[] = response.data;
      dispatch({ type: STORE_LIVEORDERDATA, liveOrderData } as AnyAction);
    }

  }).catch(function (error: AxiosError) {

    const liveOrderData: RowDataLive[] = [];
    dispatch({ type: STORE_LIVEORDERDATA, liveOrderData } as AnyAction);

  });

};
export const getHoldOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  axios({
    method: 'post',
    url: `${getState().environment.API_URL
      }loadOrderData?listType=brecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=HOLD`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    if (response.data.length === 1) {
      if (response.data[0].orderno !== '') {

        const liveOrderDataOnHold: RowDataLive[] = response.data;
        dispatch({ type: STORE_LIVEORDERDATA_ONHOLD, liveOrderDataOnHold } as AnyAction);
      } else {

        const liveOrderDataOnHold: RowDataLive[] = [];
        dispatch({ type: STORE_LIVEORDERDATA_ONHOLD, liveOrderDataOnHold } as AnyAction);
      }

    } else {

      const liveOrderDataOnHold: RowDataLive[] = response.data;
      dispatch({ type: STORE_LIVEORDERDATA_ONHOLD, liveOrderDataOnHold } as AnyAction);
    }

  }).catch(function (error: AxiosError) {

    const liveOrderDataOnHold: RowDataLive[] = [];
    dispatch({ type: STORE_LIVEORDERDATA_ONHOLD, liveOrderDataOnHold } as AnyAction);
  });

};
export const getManufactureOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  axios({
    method: 'post',
    url: `${getState().environment.API_URL
      }loadOrderData?listType=brecdon&userCode=${encodeURIComponent(getState().user.userDetails.userName)}&status=MANUFACTURER`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {
    if (response.data.length === 1) {
      if (response.data[0].orderno !== '') {

        const liveOrderDataReturned: RowDataLive[] = response.data;
        dispatch({ type: STORE_LIVEORDERDATA_RETURNED, liveOrderDataReturned } as AnyAction);
      } else {

        const liveOrderDataReturned: RowDataLive[] = [];
        dispatch({ type: STORE_LIVEORDERDATA_RETURNED, liveOrderDataReturned } as AnyAction);
      }

    } else {

      const liveOrderDataReturned: RowDataLive[] = response.data;
      dispatch({ type: STORE_LIVEORDERDATA_RETURNED, liveOrderDataReturned } as AnyAction);
    }

  }).catch(function (error: AxiosError) {

    const liveOrderDataReturned: RowDataLive[] = [];
    dispatch({ type: STORE_LIVEORDERDATA_RETURNED, liveOrderDataReturned } as AnyAction);

  });
};

export const getCancelOrderData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

  axios({
    method: 'post',
    url: `${getState().environment.API_URL
      }loadOrderData?listType=cnclord&userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    if (response.data.length === 1) {
      if (response.data[0].orderno !== '') {

        const cancelOrderData: RowDataCancel[] = response.data;
        dispatch({ type: STORE_CANCELORDERDATA, cancelOrderData } as AnyAction);
      } else {

        const cancelOrderData: RowDataCancel[] = [];
        dispatch({ type: STORE_CANCELORDERDATA, cancelOrderData } as AnyAction);
      }

    } else {

      const cancelOrderData: RowDataCancel[] = response.data;
      dispatch({ type: STORE_CANCELORDERDATA, cancelOrderData } as AnyAction);
    }

  }).catch(function (error: AxiosError) {

    const cancelOrderData: RowDataCancel[] = [];
    dispatch({ type: STORE_CANCELORDERDATA, cancelOrderData } as AnyAction);
  });

};

export const rowClick = (orderid: string, orderno: string) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    const sessionid = getState().user.userDetails.s || '';

    const searchName = '';
    dispatch({ type: STORE_SEARCHNAME, searchName } as AnyAction);

    const searchTrue = false;
    dispatch({ type: STORE_SEARCHTRUE, searchTrue } as AnyAction);

    dispatch({ type: STORE_LIVEDATA_ORDERNO, orderno } as AnyAction);
    dispatch({ type: STORE_LIVEDATA_ORDERID, orderid } as AnyAction);

    const userRxdata: UserRxFormData[] = [];
    dispatch({ type: STORE_RXORDERDATA, userRxdata } as AnyAction);

    clearDataOnOpen(dispatch, getState);

    dispatch({ type: STORE_LOADER, loader: true } as AnyAction);

    axios({
      method: 'post',
      url: `${getState().environment.API_URL}getOrderDetails?orderId=${getState().liveOrder.orderno}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: sessionid
      }
    }).then(async function (response: AxiosResponse) {
      const viewCompleteOrder: ViewCompletedOrder[] = response.data;

      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder } as AnyAction);

      if (getState().landingPage.verticalViewScreen) {

        for (const arr of [1]) {

          await axios({
            method: 'post',
            url: `${getState().environment.API_URL}getRxOrderDetails?orderId=${getState().liveOrder.orderid}`,
            headers: {
              type: arr,
              sessionid: sessionid || ''
            },
          }).then(function (resp: AxiosResponse) {

            dispatch({ type: STORE_RXORDERDATA, userRxdata: resp.data } as AnyAction);

            const designtype = getState().UserRxFormData.userRxdata[0].designtype;
            const notations = getState().UserRxFormData.userRxdata[0].notations;
            const product = getState().UserRxFormData.userRxdata[0].product;
            const productname = getState().UserRxFormData.userRxdata[0].productname;
            const model = getState().UserRxFormData.userRxdata[0].model;

            dispatch({ type: STORE_DESIGNTYPE_RXFORM, designtype } as AnyAction);
            dispatch({ type: STORE_NOTATIONS_RXFORM, notations } as AnyAction);
            dispatch({ type: STORE_PRODUCT_RXFORM, product } as AnyAction);
            dispatch({ type: STORE_PRODUCTNAME_RXFORM, productname } as AnyAction);
            dispatch({ type: STORE_MODEL_RXFORM, model } as AnyAction);

            return true;

          }).catch(error => {

            const errorFileUploadedOpen = true;
            const errorfilemsg = error.response.data.msg;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);

            return true;

          });

          await axios({
            method: 'post',
            url: `${getState().environment.API_URL}getOrderMessage?messageType=0&pid=${getState().liveOrder.orderid}`,
            headers: {
              type: arr,
              sessionid: sessionid || ''
            },
          }).then(function (resp: AxiosResponse) {

            const getUserMessage: GetUserMessage[] = resp.data;
            dispatch({ type: STORE_GETMESSAGES, getUserMessage: messageObjectTransform(getUserMessage) } as AnyAction);

          }).catch(error => {
            dispatch({ type: STORE_GETMESSAGES, getUserMessage: [] } as AnyAction);
            const errorFileUploadedOpen = true;
            const errorfilemsg = error.response.data.msg;
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
          });

          await axios({
            method: 'post',
            url: `${getState().environment.API_URL}getFiles?orderId=${getState().liveOrder.orderid}`,
            headers: {
              type: arr,
              sessionid: sessionid || ''
            },
          }).then(function (resp: AxiosResponse) {

            const getFileData: GetFileData[] = resp.data;
            dispatch({ type: STORE_GETDATAFILES, getFileData } as AnyAction);

          }).catch(function (error: AxiosError) {
            dispatch({ type: STORE_GETDATAFILES, getFileData: [] } as AnyAction);
          });

        }

        dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

        dispatch(push('/app/rxform'));

      } else {
        if (dispatch(getRxOrderData)) {

          dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

          dispatch(push('/app/rxform'));
          // setInterval(getMessage, 5000);
        }
      }

    }).catch(function (error: AxiosError) {

      dispatch({ type: STORE_LOADER, loader: false } as AnyAction);

      const viewCompleteOrder: ViewCompletedOrder[] = [];
      dispatch({ type: STORE_VIEWCOMPLETEDORDER, viewCompleteOrder } as AnyAction);
    });

    return true;
  };
};

export const rework = (column: Object, reloadPage: string) => {
  
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    axios({
      method: 'post',
      url: `${getState().environment.API_URL
        }reWorkOrder`,
      data: column,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        sessionid: getState().user.userDetails.s || ''
      }
    }).then(function (response: AxiosResponse) {
      // console.log(reloadPage, 'reloadPage');
      
      switch (reloadPage) {
        case 'new':
          getNewOrderData(dispatch, getState);
          break;
        case 'live':
          getLiveOrderData(dispatch, getState);
          break;
        case 'hold':
          getHoldOrderData(dispatch, getState);
          break;
        case 'return':
          getManufactureOrderData(dispatch, getState);
          break;
        case 'completed':
          getCompleteOrderData(dispatch, getState);
          break;
        case 'mnew':
          getMNewOrderData(dispatch, getState);
          break;
        case 'mhold':
          getMHoldOrderData(dispatch, getState);
          break;
        case 'mdesignready':
          getDesignReadyOrderData(dispatch, getState);
          break;
        case 'minproduction':
          getMInproductionOrderData(dispatch, getState);
          break;
        case 'mcompleted':
          getMCompleteOrderData(dispatch, getState);
          break;
        case 'mfilter':
          getMInproductionOrderDataFilter('', '', new Date(), new Date(), 'ALL');
          break;
        default:
          getNewOrderData(dispatch, getState);
          getHoldOrderData(dispatch, getState);
          getManufactureOrderData(dispatch, getState);
          getCompleteOrderData(dispatch, getState);
          getDesignReadyOrderData(dispatch, getState);
          getMNewOrderData(dispatch, getState);
          getMInproductionOrderData(dispatch, getState);
          getMInproductionOrderDataFilter('', '', new Date(), new Date(), 'ALL');
          break;
      }

    }).catch(error => {

      const errorFileUploadedOpen = true;
      let errorfilemsg = error.response.data.msg;

      if (error.response.data.msg.indexOf('ORA-00001: unique constraint') !== -1) {
        errorfilemsg = 'Re-design request has been already submitted for this order';
      }

      dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
      dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
    });
    return true;
  };
};

export const approvalReqd = (array: Array<object>, status: string, dispatch: Dispatch<AppState>, getState: () => AppState) => {

  const request = {
    columns: array,
    status: status
  };

  axios({
    method: 'PUT',
    url: `${getState().environment.API_URL
      }approvalRequired`,
    data: request,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      sessionid: getState().user.userDetails.s || ''
    }
  }).then(function (response: AxiosResponse) {

    getManufactureOrderData(dispatch, getState);
  }).catch(error => {

    const errorFileUploadedOpen = true;
    const errorfilemsg = error.response.data.msg;

    dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
    dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
  });

  return true;
};

export const approvalRequired = (array: Array<object>) => {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    approvalReqd(array, '', dispatch, getState);
    // using the same download api for approval also
    return true;
  };
};



// WEBPACK FOOTER //
// ./src/actions/liveOrderAction.ts